import { useState } from "react";
import { Loader2, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { apiErrorText } from "@/lib/adminHelpers";

export const consultingLabel = (c) => {
  if (!c) return "Yok";
  if (c.status !== "active") return c.status || "Yok";
  const ends = c.ends_at ? Date.parse(c.ends_at) : null;
  return ends !== null && ends < Date.now() ? "Süresi doldu" : "Aktif";
};

const SOURCE_LABEL = { free_first_100: "ücretsiz (ilk 100)", paid: "ödemeli", manual: "manuel" };
const day = (iso) => (iso ? new Date(iso).toLocaleDateString("tr-TR") : "-");

// Presentational + tiny state: onGrant(source) must resolve or throw (axios error).
export function ConsultingControl({ consulting, onGrant }) {
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState("");

  const grant = async (source) => {
    setBusy(source);
    setError("");
    try {
      await onGrant(source);
    } catch (e) {
      setError(apiErrorText(e, "Danışmanlık verilemedi"));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="mt-3 rounded-lg border border-dashed p-3" data-testid="consulting-control">
      <div className="mb-2 flex items-center justify-between">
        <h4 className="flex items-center gap-1.5 text-sm font-semibold">
          <LifeBuoy className="h-4 w-4" /> Danışmanlık
        </h4>
        <Badge variant="outline" data-testid="consulting-status">{consultingLabel(consulting)}</Badge>
      </div>
      {consulting && (
        <p className="mb-2 text-xs text-muted-foreground" data-testid="consulting-details">
          Bitiş: {day(consulting.ends_at)} · Kullanılan talep: {consulting.tickets_used ?? 0}
          {consulting.source ? ` · Kaynak: ${SOURCE_LABEL[consulting.source] || consulting.source}` : ""}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" disabled={!!busy} onClick={() => grant("free_first_100")} data-testid="consulting-grant-free">
          {busy === "free_first_100" && <Loader2 className="h-3 w-3 animate-spin" />}
          Ücretsiz ver (ilk 100)
        </Button>
        <Button size="sm" variant="outline" disabled={!!busy} onClick={() => grant("manual")} data-testid="consulting-grant-manual">
          {busy === "manual" && <Loader2 className="h-3 w-3 animate-spin" />}
          Manuel ver
        </Button>
      </div>
      {error && <p className="mt-2 text-xs text-red-600" role="alert" data-testid="consulting-error">{error}</p>}
    </div>
  );
}
